// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/reset.css'

import axios from 'axios'
import VueAxios from 'vue-axios'
import {Lazyload} from 'vant';
import VueWechatTitle from 'vue-wechat-title';
import VueCropper from 'vue-cropper'

Vue.use(VueAxios, axios);
Vue.use(Lazyload);
Vue.config.productionTip = false
Vue.use(VueWechatTitle)
Vue.use(VueCropper)// 图片裁剪

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js